export default [{
    path: '/my',
    component: ()=> import("@/views/My"),
    redirect:"/userInfo",
    meta:{
    },
    children:[
        {
            path: '/userInfo',
            component: ()=> import("@/views/UserInfo"),
            meta:{
                title:"个人资料"
            },
            children:[
                
            ]
        },
        {
            path: '/setPwd',
            component: ()=> import("@/views/SetPwd"),
            meta:{
                title:"修改密码"
            },
            children:[
                
            ]
        },
        {
            path: '/address',
            component: ()=> import("@/views/Address"),
            meta:{
                title:"收货地址"
            },
            children:[
                
            ]
        },
        {
            path: '/fast',
            component: ()=> import("@/views/Fast"),
            meta:{
                title:"快速下单"
            },
            children:[
                
            ]
        },

        {
            path: '/orderList',
            component: ()=> import("@/views/OrderList"),
            meta:{
                title:"我的订单"
            },
            children:[
                
            ]
        },
        
    ]
}]